import { httpClient } from './api/httpClient';
import { isMockEnabled, mockResponse } from './api/mockAdapter';
import { API_ENDPOINTS } from 'constants/apiEndpoints';
import { MOCK_STORAGE1 } from 'mock/pipeline.mock';

export const toStorage1 = (raw) =>
  raw && {
    id: raw.id,
    sourceModule: raw.workflow?.routing_destination ?? raw.source_module ?? raw.sourceModule ?? '',
    newspaperName: raw.newspaper_name ?? raw.newspaperName ?? '',
    edition: raw.edition ?? '',
    keyword: raw.keywords ?? raw.keyword ?? [],
    articleLink: raw.article_image_url ?? raw.article_link ?? raw.articleLink ?? '',
    newspaperLink: raw.newspaper_page_image_url ?? raw.newspaper_link ?? raw.newspaperLink ?? '',
    mergedPdfLink: raw.merged_pdf_url ?? raw.merged_pdf_link ?? raw.mergedPdfLink ?? null,
    gdriveLink: raw.metadata?.gdrive_link ?? raw.gdriveLink ?? null,
    mergeStatus: raw.merged_pdf_status ?? raw.merge_status ?? raw.mergeStatus ?? 'pending',
    bundleId: raw.bundle_id ?? raw.bundleId ?? null,
    pageNumber: raw.page_number ?? raw.pageNumber ?? null,
    status: raw.workflow?.status ?? raw.status ?? 'routed',
    workflow: raw.workflow ?? null,
    routing: raw.routing ?? null,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
    isManualUpload: raw.is_manual_upload ?? false,
    source: raw.source?.type ?? raw.source ?? '',
  };

let articles = MOCK_STORAGE1.map((r) => ({ ...r }));

export const ocrStorageService = {
  async fetchArticles(params = {}) {
    if (isMockEnabled()) {
      let filtered = articles;
      if (params.newspaper_name) {
        filtered = filtered.filter(a => a.newspaper_name === params.newspaper_name || a.newspaperName === params.newspaper_name);
      }
      return {
        items: filtered.slice(0, 10).map(toStorage1),
        total: filtered.length,
        page: params.page || 1,
        pageSize: params.page_size || 10,
        totalPages: Math.ceil(filtered.length / (params.page_size || 10))
      };
    }
    const data = await httpClient.get(API_ENDPOINTS.OCR_STORAGE.LIST, { params });
    return {
      ...data,
      items: data.items.map(toStorage1),
      pageSize: data.page_size,
      totalPages: data.total_pages,
    };
  },

  async fetchArticleById(id) {
    if (isMockEnabled()) {
      return toStorage1(articles.find((a) => a.id === id) || {});
    }
    const data = await httpClient.get(API_ENDPOINTS.OCR_STORAGE.GET.replace(':id', id));
    return toStorage1(data);
  },

  async manualUploadOCR(formData) {
    if (isMockEnabled()) {
      return await mockResponse(toStorage1(articles[0] || {}));
    }
    const data = await httpClient.post(API_ENDPOINTS.OCR_STORAGE.MANUAL_UPLOAD_OCR, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000, // 5 minutes for OCR processing
    });
    return toStorage1(data);
  },

  async checkExists(newspaperName, edition, date) {
    if (isMockEnabled()) {
      return await mockResponse({ exists: false });
    }
    const data = await httpClient.get(API_ENDPOINTS.OCR_STORAGE.CHECK_EXISTS, {
      params: { newspaper_name: newspaperName, edition, date }
    });
    return data.exists;
  },
};

export default ocrStorageService;
